import * as yup from "yup";

import { Shape } from "@/core/yup";
import { fakeI18n } from "@/i18n";

export interface PasswordFormType {
    password: string;
}

export const passwordValidationSchema = yup.object<{}, Shape<PasswordFormType>>({
    //, fakeI18n.t("Validations.PasswordComplexity")
    password: yup.string().test("password-complexity", "", (value) => {
        if (!value) return false;

        if (value.length < 12) return false;

        const uppercase = /[A-Z]/.test(value);
        const lowercase = /[a-z]/.test(value);
        const number = /[0-9]/.test(value);
        const specialChar = /[ !"#$%&'()*+,-./:;<=>?@[\\\]^_`{|}~]/.test(value);

        // Count how many of the categories are satisfied
        const complexityCount = [uppercase, lowercase, number, specialChar].filter(Boolean).length;

        return complexityCount >= 3;
    }),
});

export const legacyPasswordValidationSchema = yup.object<{}, Shape<PasswordFormType>>({
    password: yup
        .string()
        .min(6)
        .required(fakeI18n.t("Validations.MinLength", { number: 6 })),
});

export interface EmailFormType {
    email: string;
}

export const emailValidationSchema = yup.object<{}, Shape<EmailFormType>>({
    email: yup.string().email().required(),
});
